import React from 'react'

const Columns = ({attrs}) =>
	<div className={'wp-columns has-'+attrs.columns_nb_columns+'-columns'}>
		{Object.keys(attrs).map(i => i.startsWith("columns_column_") && <div key={i} className={`wp-columns-column ${i}`} dangerouslySetInnerHTML={{__html: attrs[i]}} />)}
	</div>

export default Columns
